import { IonFooter } from '@ionic/react'
import { observer } from 'mobx-react'
import { doProductMobx } from 'mobx/mall'
import { decorationMobx } from '@mobxStore'
import React, { FC, useState, useEffect, Fragment } from 'react'
import { format } from '@dt/fe-utils'
import { getHistoryNew, modalLayer } from '@utils'
import { ScaleModal } from '../../modal'
import { ShopCartBar } from '@pages/mall/mall/components'
import { TCheckoutType } from '@ctrls/mallController'
import './index.scss'

interface IProps {
  soldOut?: boolean;
  addToCart: (type: string) => void;
  disableScale?: boolean;
  disabled?: boolean;
}

const Footer: FC<IProps> = ({ soldOut = false, disableScale, addToCart, disabled }) => {
  const history = getHistoryNew()
  const [isGroup, setIsGroup] = useState(false)
  const totalPrice = doProductMobx.doProductResult.totalPrice
  const totalActualPrice = doProductMobx.doProductResult.totalActualPrice
  const groupBuyPrice = doProductMobx.doProductResult.groupBuyPrice
  const { mallGlobalDecorates: { cartAndBuy } } = decorationMobx
  // 当前用户语言是否是商户语言
  const isLikeLang = Config.i18n.toLowerCase().indexOf(bo) > -1
  useEffect(() => {
    setIsGroup(!!groupBuyPrice)
  }, [groupBuyPrice])
  const handleTackIt = (type: TCheckoutType = TCheckoutType.Buy) => {
    if (doProductMobx.doProduct.scaleNo === '0') {
      addToCart(type)
    } else {
      modalLayer(ScaleModal, { disableScale, payType: type }, 'ScaleModal').then(() => {
        addToCart(type)
      }).catch(() => {
      })
    }
  }
  return (
    <IonFooter className='mall-footer-btn-wrap'>
      <div className='footer-btn'>
        <button className='white-btn btn'>
          <ShopCartBar hasTxt />
        </button>
        {
          soldOut ? (
            <button className='primary-btn disabled dubble'>{i18n.t('common.soldout')}</button>
          ) : isGroup ? (
            <Fragment key={doProductMobx.doProduct.no}>
              <button
                className={`grey-btn${disabled ? ' disabled' : ''} oneHelf`}
                onClick={() => handleTackIt(TCheckoutType.Cart)}
              >
                {(isLikeLang && cartAndBuy?.cart) || i18n.t('productdetail.addCart')}
              </button>
              <button
                className={`default-btn${disabled ? ' disabled' : ''} oneHelf`}
                onClick={() => handleTackIt(TCheckoutType.Buy)}
              >
                <div className='btn-wrap'>
                  <div className='price-wrap'>{format.toPrice(totalActualPrice)}{totalPrice !== totalActualPrice ? <span>{format.toPrice(totalPrice)}</span> : null}</div>
                  <div className='btn-txt'>{i18n.t('productdetail.singleBuy')}</div>
                </div>
              </button>
              <button
                className={`primary-btn${disabled ? ' disabled' : ''} oneHelf`}
                onClick={() => handleTackIt(TCheckoutType.Group)}
              >
                <div className='btn-wrap'>
                  <div className='price-wrap'>{format.toPrice(groupBuyPrice)}</div>
                  <div className='btn-txt'>{i18n.t('productdetail.groupBuy')}</div>
                </div>
              </button>
            </Fragment>
          ) : (
            <Fragment key={doProductMobx.doProduct.no}>
              <button
                className={`grey-btn${disabled ? ' disabled' : ''} dubble`}
                onClick={() => handleTackIt(TCheckoutType.Cart)}
              >
                {(isLikeLang && cartAndBuy?.cart) || i18n.t('productdetail.addCart')}
              </button>
              <button
                className={`primary-btn${disabled ? ' disabled' : ''} dubble`}
                onClick={() => handleTackIt(TCheckoutType.Buy)}
              >
                {(isLikeLang && cartAndBuy?.buy) || i18n.t('productdetail.buyNow')}
              </button>
            </Fragment>
          )
        }
      </div>
    </IonFooter>
  )
}

export default observer(Footer)
